import Link from "next/link"
import React from "react"
import { imageResizer } from "../../../services/utils/imageResizer"
import { Image } from "../Layout/Image"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"

export const DiscoverMasonry = ({ items }) => {
  const Item = ({
    title,
    subtitle,
    subSubTitle,
    image,
    to,
    href,
    sold,
    price,
  }) => {
    const Card = () => (
      <div className="m-2">
        <Image
          src={imageResizer(image, 800, "AUTO")}
          alt={title}
          className="mb-2"
        />
        <div className="">
          <h4 className="text-black mb-0 font-secondary fw-700 fs-16px">
            {title}
          </h4>
          {subtitle && (
            <p className="mb-0 font-secondary text-black fs-14px">{subtitle}</p>
          )}
          {subSubTitle && (
            <p className="mb-0 color-gray-super-light fs-13px font-primary fs-09em">
              {subSubTitle}
            </p>
          )}
          {sold && (
            <span className="mb-0 text-black fs-14px font-secondary fw-700">
              Sold
            </span>
          )}
          {!sold && price && (
            <span className="mb-0 text-black fs-14px font-secondary fw-700">
              {price}
            </span>
          )}
        </div>
      </div>
    )

    if (to && href) {
      return (
        <Link href={href} as={to}>
          <Card />
        </Link>
      )
    }

    return <Card />
  }

  return (
    <ResponsiveMasonry
      columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1200: 4 }}>
      <Masonry>
        {items.map((item, i) => (
          <Item key={item.to || `${item.image}-${i}`} {...item} />
        ))}
      </Masonry>
    </ResponsiveMasonry>
  )
}
